<template>
  <b-modal
    v-model="showNotice"
    hide-header-close
    centered
    :ok-title="$t('verifyModalOkTitle')"
    :cancel-title="$t('verifyModalCancelTitle')"
    :title="$t('verifyModalTitle')"
    no-close-on-backdrop
    no-close-on-esc
    @ok="showVerifyModal"
    id="verify-notice-modal"
    @hidden="hideModal"
  >
    <div v-html="$t('verifyModalText')"></div>
  </b-modal>
</template>
  <script>
import { mapGetters } from 'vuex';

export default {
  data: function () {
    return {
      showNotice: false,
    };
  },
  watch: {
    showVerifyNotice: function (value) {
      if (value) {
        this.$root.$emit('bv::show::modal', 'verify-notice-modal');
      } else {
        this.$root.$emit('bv::hide::modal', 'verify-notice-modal');
      }
    },
  },
  computed: {
    ...mapGetters({
      showVerifyNotice: 'auth/showVerifyNotice',
      isUserVerified: 'auth/isUserVerified',
      isLoggedIn: 'auth/isLoggedIn',
      user: 'auth/user',
    }),
  },
  mounted() {
    if (this.isLoggedIn && !this.isUserVerified) {
      setTimeout(() => {
        this.$store.dispatch('auth/showVerifyNotice');
      }, 5000);
    }
  },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'auth',
  },
  methods: {
    hideModal: function () {
      this.$store.dispatch('auth/hideVerifyNotice');
    },
    showVerifyModal() {
      this.$router.push('/profile');
    },
  },
};
</script>
  <style lang="scss" scoped>
.alert {
  background: $dark-blue;
  color: $white;
}
</style>
